//randomizer function for the answers
export const shuffleArray = (array: any[]) => 
    [...array].sort(() => Math.random() - 0.5);